/**
 * Self-Service Calculator
 *
 * Contact: dap@visana.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { MedicalOfficesSearchResults } from '../model/medicalOfficesSearchResults';
// @ts-ignore
import { Problem } from '../model/problem';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class MedicalOfficesByNameOrZipCodeService {

    protected basePath = '/api/public';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Search for medical offices by name or zip code
     * @param name Search query to look up medical offices by doctor or office name
     * @param zip Search query to look up medical offices by zip code
     * @param saleOfferBegin 
     * @param insuranceModelType Search query to look up medical offices by insurance model type
     * @param insuredZipCode Zip code of the person to be insured, used to determine the medical network of the insurance model type
     * @param insuredBfsNumber Bfs number (municipality number) of the person to be insured, used to determine the medical network of the insurance model type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchMedicalOfficesByNameOrZipCode(name: string, zip: string, saleOfferBegin: string, insuranceModelType: string, insuredZipCode: string, insuredBfsNumber: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json', context?: HttpContext, transferCache?: boolean}): Observable<MedicalOfficesSearchResults>;
    public searchMedicalOfficesByNameOrZipCode(name: string, zip: string, saleOfferBegin: string, insuranceModelType: string, insuredZipCode: string, insuredBfsNumber: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MedicalOfficesSearchResults>>;
    public searchMedicalOfficesByNameOrZipCode(name: string, zip: string, saleOfferBegin: string, insuranceModelType: string, insuredZipCode: string, insuredBfsNumber: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MedicalOfficesSearchResults>>;
    public searchMedicalOfficesByNameOrZipCode(name: string, zip: string, saleOfferBegin: string, insuranceModelType: string, insuredZipCode: string, insuredBfsNumber: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling searchMedicalOfficesByNameOrZipCode.');
        }
        if (zip === null || zip === undefined) {
            throw new Error('Required parameter zip was null or undefined when calling searchMedicalOfficesByNameOrZipCode.');
        }
        if (saleOfferBegin === null || saleOfferBegin === undefined) {
            throw new Error('Required parameter saleOfferBegin was null or undefined when calling searchMedicalOfficesByNameOrZipCode.');
        }
        if (insuranceModelType === null || insuranceModelType === undefined) {
            throw new Error('Required parameter insuranceModelType was null or undefined when calling searchMedicalOfficesByNameOrZipCode.');
        }
        if (insuredZipCode === null || insuredZipCode === undefined) {
            throw new Error('Required parameter insuredZipCode was null or undefined when calling searchMedicalOfficesByNameOrZipCode.');
        }
        if (insuredBfsNumber === null || insuredBfsNumber === undefined) {
            throw new Error('Required parameter insuredBfsNumber was null or undefined when calling searchMedicalOfficesByNameOrZipCode.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (name !== undefined && name !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>name, 'name');
        }
        if (zip !== undefined && zip !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>zip, 'zip');
        }
        if (saleOfferBegin !== undefined && saleOfferBegin !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>saleOfferBegin, 'sale_offer_begin');
        }
        if (insuranceModelType !== undefined && insuranceModelType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>insuranceModelType, 'insurance_model_type');
        }
        if (insuredZipCode !== undefined && insuredZipCode !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>insuredZipCode, 'insured_zip_code');
        }
        if (insuredBfsNumber !== undefined && insuredBfsNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>insuredBfsNumber, 'insured_bfs_number');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/problem+json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/medical-offices-by-name-or-zip-codes`;
        return this.httpClient.request<MedicalOfficesSearchResults>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
